var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xBC\x96\xE7\xBB\x84-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xBC\x96\xE7\xBB\x84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-307",
    d: "M23.2884 4.1084H6.66849C5.09507 4.1084 1.94824 4.98769 1.94824 8.68959C1.94824 12.3915 5.09507 13.3238 6.66849 13.3238H20.4061C21.9795 13.3238 25.025 14.2284 25.025 17.9303C25.025 21.6322 21.9795 22.5562 20.4061 22.5562H3.13958",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-309",
    d: "M4.28246 20.2427L1.9873 22.5887L4.28246 24.8623",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-309_2",
    d: "M21.5886 1.75879L23.8838 4.10485L21.5886 6.37841",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/testIcon.a378576d874b9e95a7ca6f1f658d089f.svg";
export { ForwardRef as ReactComponent };